import RedemptionFormFooter from './RedemptionFormFooter';

export default RedemptionFormFooter;
